module.exports = __webpack_public_path__ + "img/ticket-pattern-0.33072d82.svg";